/* eslint-disable jsx-a11y/no-static-element-interactions */
import { cn } from "@babybjorn/ui";
import type { FC, PropsWithChildren } from "react";
import Button from "../../../components/general/Button";
import * as s from "./Modal.module.scss";

type ModalProps = PropsWithChildren<{
	closeButtonLabel: string;
	overlayOnClick: () => void;
	buttonOnClick: () => void;
	heading?: string;
	description?: string;
	variant?: "fabric" | "share" | "language" | "filter";
}>;

const Modal: FC<ModalProps> = ({
	children,
	closeButtonLabel,
	buttonOnClick,
	overlayOnClick,
	heading,
	description,
	variant,
}) => {
	const headerClassNames = cn(s.headerWrapper, {
		[s.share]: variant === "share",
	});

	return (
		<div className={s.modalWrapper}>
			{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
			<div className={s.clickableOverlay} onClick={overlayOnClick} />
			<aside className={s.modal}>
				<section className={headerClassNames}>
					<Button
						onClick={buttonOnClick}
						variant="noBg"
						iconLeft
						icon="close"
						buttonType="standard"
						label={closeButtonLabel}
						noPaddingInline
					/>
					{heading && (
						<header className={s.headerContent}>
							{heading && <h3 className={s.title}>{heading}</h3>}
							{description && <p className={s.description}>{description}</p>}
						</header>
					)}
				</section>
				<ul className={s.modalList}>{children}</ul>
			</aside>
		</div>
	);
};
export default Modal;
